import { apiClient } from "helpers/api_helper"

export const getEcomDraftOrderList = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/ProductDetails/GetEcomProductDetailsByProductHeaderId`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
